import React, { Component } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Badge from '@mui/material/Badge';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import TableViewIcon from '@mui/icons-material/TableView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; 
import ExpandLessIcon from '@mui/icons-material/ExpandLess'; 
import MasterIcon from '@mui/icons-material/Folder'; 
import LogoutIcon from '@mui/icons-material/Logout';

import masterIconImg from './images/DASHBOARD.png';
import hoverMasterIconImg from './images/DASHBOARD-HOVER.png';

import innerPFSlogo from './images/LOGO-DASHBOARD.jpg';
import smalllogo from './images/pfslogo.jpg';
import notification from './images/NOTIFICATION.png';
import person from './images/person.jpg';
import arrowimg from './images/DASHBOARD-UI-CLOSE.png';

import itemIcon from './images/ITEM-MANAGEMENT.png';
import inspectionIcon from './images/INSPECTION-BOOKING.png';
import serviceQuoteIcon from './images/SERVICE-QUOTE.png';
import blogIcon from './images/BLOG-MANAGEMENT.png';
import notificationIcon from './images/NOTIFICATION.png';
import reportIcon from './images/REPORTS.png';       
import reportActiveIcon from './images/REPORTS-HOVER.png';  
import itemActiveIcon from './images/ITEM-MANAGEMENT-HOVER.png';
import inspectionActiveIcon from './images/INSPECTION-BOOKING-HOVER.png';
import serviceQuoteActiveIcon from './images/SERVICE-QUOTE-HOVER.png';
import blogActiveIcon from './images/BLOG-MANAGEMENT-HOVER.png';
import notificationActiveIcon from './images/NOTIFICATION-HOVER.png';
import adminProfileIcon from './images/adminprofile.png';

import Serverurl from './Apiurl';


const drawerWidth = 270;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default class AppLayout extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      open: false, menuMastersOpen: false,
      open1: false, 
      invisible: true,
      menu1: false,
      menu3: false, 
      anchorEl: false, 
      menuopen: false, 
      menu2: false, 
      ldcnt: 0 
    };
  }

  handleMenuMastersToggle = () => {
  this.setState((prevState) => ({ menuMastersOpen: !prevState.menuMastersOpen }));
};

  handleDrawerOpen = (e) => {
    this.setState({ open: !this.state.open });
  };
   
  handleClick = (e) => {
    this.setState({ anchorEl: e.currentTarget, menuopen: !this.state.menuopen });
  };
  
  handleClose = (e) => {
    this.setState({ anchorEl: null, menuopen: false });
  };

  handlemenu1 = (e) => {
    this.setState({ menu1: !this.state.menu1 });
  };

  handlemenumaster = (e) => {
    this.setState({ menu2: !this.state.menu2 });
  };

  handlemenuaction = (e) => {
    this.setState({ menu3: !this.state.menu3 });
  };
   
  handleCallleadcnt = (childData) => {
    this.setState({ ldcnt: childData });
  };

  render() {
	 const formatName = (name, isOpen) => {
  if (!name) return "User";

  const limit = isOpen ? 8 : 10; 

  return name.length > limit ? name.substring(0, limit) + ".." : name;
};

const displayName = formatName(localStorage.getItem("DCname"), this.state.open);

	  const DCrole = localStorage.getItem('DCrole');
    return (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
<AppBar position="fixed" open={this.state.open}>
  <Toolbar className="adminheaderbg">
    <IconButton
      color="inherit"
      className="logobtn"
      aria-label="open drawer"
      onClick={this.handleDrawerOpen}
      edge="start"
      sx={{ mr: 2, ...(this.state.open && { display: 'none' }) }}
    >
      <MenuIcon />
	   <img src={smalllogo} />
    </IconButton>

    <div className="accountsec">
      <ul className="linkslist">
        <li>
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <div className="submenus" onClick={this.handleClick} size="small" sx={{ ml: 2 }}>
              <SettingsOutlinedIcon />
            </div>
          </Box>

          {/* Settings Menu */}
          <Menu
            anchorEl={this.state.anchorEl}
            open={this.state.menuopen}
            onClose={this.handleClose}
            onClick={this.handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 40,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
           <MenuItem>
  <div className="setingdiv" style={{ display: 'flex', alignItems: 'center' }}>
    <SettingsOutlinedIcon style={{ color:'grey',marginRight: '10px' }} />
    <NavLink to="/Staffchangepassword" className="colorlink">
      Change Password
    </NavLink>
  </div>
</MenuItem>

<MenuItem>
  <div className="setingdiv" style={{ display: 'flex', alignItems: 'center' }}>
    <LogoutIcon style={{ color:'grey',marginRight: '10px' }} />
    <NavLink to="/" className="colorlink">
      Logout
    </NavLink>
  </div>
</MenuItem>
          </Menu>
        </li>

        <li>
		 <div className="accountlogin">
            <h1 style={{ fontSize: '12px', margin: 0 }}>Hello, {displayName}</h1>
            <h4 style={{ margin: '5px 0 0 0' }}>Welcome to Prep4Sale</h4>
          </div>
          <div className="accounticon">
            <img
  src={adminProfileIcon}
  alt="Admin"
/>
          </div>         
        </li>
      </ul>
    </div>
  </Toolbar>
</AppBar>        
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          variant="persistent"
          anchor={'left'} 
          className="slidebg"
          open={this.state.open}
        >
          <DrawerHeader className="headerlogo">
            <img src={innerPFSlogo} style={{marginRight:'28px' , width:"150px"}} alt="Logo" />
            <IconButton onClick={this.handleDrawerOpen}>
<img src={arrowimg} alt="Close Drawer" style={{marginTop:'10px', width: '20px', height: '20px' }} />            </IconButton>
          </DrawerHeader>
          
<List className="adminmenu">
{DCrole === "1" && ( 
  <ListItem sx={{mb:1.5}} onClick={this.handleMenuMastersToggle} button>
    <img
      src={this.state.menuMastersOpen ? hoverMasterIconImg : masterIconImg}
      alt="Master Icon"
      style={{ width: '25px', height: '25px' }}  
    />
    <span style={{ fontWeight:500,marginLeft: '10px', flexGrow: 1, color: this.state.menuMastersOpen ? '#77b138' : 'inherit' }}>
      MASTERS
    </span>
    {this.state.menuMastersOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}

  </ListItem>
)}  
  {this.state.menuMastersOpen && (
    <List className="adminsubmenu">
	<ListItem><NavLink to="/AdminStaffmanagement"><ChevronRightIcon className="iconvertical"/> Manage Staff</NavLink></ListItem>  
      <ListItem><NavLink to="/Bannermanagement"><ChevronRightIcon className="iconvertical"/> Banners </NavLink></ListItem>     
      <ListItem><NavLink to="/SlotManagement"><ChevronRightIcon className="iconvertical"/> Slots </NavLink></ListItem>
	  <ListItem><NavLink to="/ServiceManagement"><ChevronRightIcon className="iconvertical"/> Services </NavLink></ListItem>
      <ListItem><NavLink to="/Serviceprovidermanagement"><ChevronRightIcon className="iconvertical"/> Service Providers</NavLink></ListItem> 
	  <ListItem><NavLink to="/CustomerManagement"><ChevronRightIcon className="iconvertical"/> Manage Customers</NavLink></ListItem>	    	  
    </List>
  )}
{DCrole === "1" && ( 
  <div style={{
    height: '1px',
    backgroundColor: '#b6b6b6',
    margin: '15px 16px 5px 16px'
  }} />
)}
{(DCrole === "1" || DCrole === "2") && (
<ListItem>
  <NavLink
    to="/ItemManagement"
    className={({ isActive }) =>
      isActive ? "menu-link active" : "menu-link"
    }
  >
    {({ isActive }) => (
      <>
        <img
          src={isActive ? itemActiveIcon : itemIcon}
          className="menu-icon"
          alt="Item Management"
        />
        ITEM MANAGEMENT
      </>
    )}
  </NavLink>
</ListItem>
)}
{/*{(DCrole === "3") && (
<ListItem>
  <NavLink
    to="/LoginStaffs"
    className={({ isActive }) =>
      isActive ? "menu-link active" : "menu-link"
    }
  >
    {({ isActive }) => (
      <>
        <img
          src={isActive ? hoverMasterIconImg : masterIconImg}
          className="menu-icon"
          alt="Dashboard"
        />
        DASHBOARD
      </>
    )}
  </NavLink>
</ListItem>
)}*/}
{(DCrole === "1" || DCrole === "3") && (
<ListItem>
  <NavLink
    to="/InspectionBooking"
    className={({ isActive }) =>
      isActive ? "menu-link active" : "menu-link"
    }
  >
    {({ isActive }) => (
      <>
        <img
          src={isActive ? inspectionActiveIcon : inspectionIcon}
          className="menu-icon"
          alt="Inspection Bookings"
        />
        INSPECTION BOOKINGS
      </>
    )}
  </NavLink>
</ListItem>
)}

{(DCrole === "1" || DCrole === "2") && (
<ListItem>
  <NavLink
    to="/ServiceQuote"
    className={({ isActive }) =>
      isActive ? "menu-link active" : "menu-link"
    }
  >
    {({ isActive }) => (
      <>
        <img
          src={isActive ? serviceQuoteActiveIcon : serviceQuoteIcon}
          className="menu-icon"
          alt="Request Quotes"
        />
        REQUESTED QUOTES
      </>
    )}
  </NavLink>
</ListItem>
)}
{DCrole === "1" && ( 
<ListItem>
  <NavLink
    to="/BlogManagement"
    className={({ isActive }) =>
      isActive ? "menu-link active" : "menu-link"
    }
  >
    {({ isActive }) => (
      <>
        <img
          src={isActive ? blogActiveIcon : blogIcon}
          className="menu-icon"
          alt="Blog Management"
        />
        BLOG MANAGEMENT
      </>
    )}
  </NavLink>
</ListItem>
)}
{DCrole === "1" && ( 
<ListItem>
  <NavLink
    to="/ReactBigCalendar"
    className={({ isActive }) =>
      isActive ? "menu-link active" : "menu-link"
    }
  >
    {({ isActive }) => (
      <>
        <img
          src={isActive ? notificationActiveIcon : notificationIcon}
          className="menu-icon"
          alt="Notifications"
        />
        NOTIFICATIONS
      </>
    )}
  </NavLink>
</ListItem>  
)}
{(DCrole === "1" || DCrole === "2" || DCrole === "3") && (

    <div style={{
    height: '1px',
    backgroundColor: '#b6b6b6',
    margin: '15px 16px 5px 16px'
  }} />
)}
{(DCrole === "1" || DCrole === "2" || DCrole === "3") && (
  <ListItem onClick={this.handlemenu1} >
    <img
      src={this.state.menu1 ? reportActiveIcon : reportIcon}
      alt="Reports Icon"
      style={{ width: '25px', height: '25px' }}
    />
    <span style={{ fontWeight:500,marginLeft: '10px', flexGrow: 1, color: this.state.menu1 ? '#77b138' : 'inherit' }}>
      REPORTS
    </span>
    {this.state.menu1 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </ListItem>
)} 
{this.state.menu1 && (
  <List className="adminsubmenu">

    {(DCrole === "1" || DCrole === "3") && (
      <ListItem>
        <NavLink to="/InspectionBookingReport">
          <ChevronRightIcon className="iconvertical" />
          Inspection Report
        </NavLink>
      </ListItem>
    )}

    {(DCrole === "1" || DCrole === "2") && (
      <ListItem>
        <NavLink to="/ServiceQuoteReport">
          <ChevronRightIcon className="iconvertical" />
          Service Report
        </NavLink>
      </ListItem>
    )}

  </List>
)}
</List>

        </Drawer> 
        
        <Main open={this.state.open} className="drawerpad">
          <DrawerHeader />
          <div className="contentmain">
            <Outlet />
          </div>
          <div className="footerbg">
            <p>© Copyright {(new Date().getFullYear())} Prep4Sale, All Rights Reserved</p>
          </div>
        </Main>
      </Box>
    );
  }
}
